import NextLink from 'next/link';
import PropTypes from 'prop-types';
import { Box, ButtonBase } from '@mui/material';

export const SideNavItem = (props) => {
  const { active = false, disabled, external, icon, path, title, badge, compact = false } = props;

  const linkProps = path
    ? external
      ? { component: 'a', href: path, target: '_blank', rel: 'noopener' }
      : { component: NextLink, href: path }
    : {};

  return (
    <li>
      <ButtonBase
        aria-label={compact ? title : undefined}
        disabled={disabled}
        sx={{
          alignItems: 'center',
          borderRadius: 1,
          display: 'flex',
          justifyContent: compact ? 'center' : 'flex-start',
          position: 'relative',
          width: '100%',
          minHeight: 44,
          px: compact ? 0 : 2,
          py: compact ? 0.5 : 0.75,
          textAlign: 'left',
          ...(active && {
            backgroundColor: 'rgba(255, 255, 255, 0.06)',
            '&::before': {
              content: '""',
              position: 'absolute',
              left: 0,
              top: 6,
              bottom: 6,
              width: 3,
              borderRadius: 2,
              backgroundColor: 'primary.main'
            }
          }),
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.04)'
          }
        }}
        {...linkProps}
      >
        {icon && (
          <Box
            component="span"
            sx={{
              alignItems: 'center',
              color: active ? 'primary.main' : 'neutral.400',
              display: 'inline-flex',
              justifyContent: 'center',
              mr: compact ? 0 : 2,
              width: compact ? 48 : 'auto',   // área clickeable pareja
              height: compact ? 40 : 'auto'
            }}
          >
            {icon}
          </Box>
        )}

        {/* Label: se oculta en modo compacto */}
        {!compact && (
          <Box
            component="span"
            sx={{
              color: disabled ? 'neutral.500' : (active ? 'common.white' : 'neutral.400'),
              flexGrow: 1,
              fontFamily: (theme) => theme.typography.fontFamily,
              fontSize: 14,
              fontWeight: 600,
              lineHeight: '24px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}
          >
            {title}
          </Box>
        )}

        {/* Etiqueta a la derecha del label (ej. "Inactiva" en las obras cerradas).
            Va aparte de `title` porque ese string se usa como aria-label y como tooltip. */}
        {!compact && badge && (
          <Box
            component="span"
            sx={{
              ml: 1,
              px: 0.75,
              py: 0.125,
              flexShrink: 0,
              borderRadius: 1,
              fontSize: 10,
              fontWeight: 700,
              lineHeight: '18px',
              letterSpacing: '0.02em',
              color: 'neutral.400',
              backgroundColor: 'rgba(255, 255, 255, 0.08)'
            }}
          >
            {badge}
          </Box>
        )}
      </ButtonBase>
    </li>
  );
};

SideNavItem.propTypes = {
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  external: PropTypes.bool,
  icon: PropTypes.node,
  path: PropTypes.string,
  title: PropTypes.string.isRequired,
  badge: PropTypes.string,
  compact: PropTypes.bool
};
